import React from 'react';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';

import styles from './Description.style';

const Description = ({ description, descriptionPlaceHolders, extraTexts }) => {
  return (
    <>
      {description && (
        <VFText
          i18nKey={description}
          placeHolders={descriptionPlaceHolders}
          type="primary"
          style={styles.descriptionStyle}
        />
      )}

      {Array.isArray(extraTexts) &&
        extraTexts.map(({ key, placeHolders, marginTop = 19 }) => (
          <VFText
            i18nKey={key}
            placeHolders={placeHolders}
            type="primary"
            style={styles.textStyle(marginTop)}
          />
        ))}
    </>
  );
};

Description.propTypes = {
  description: PropTypes.string,
  descriptionPlaceHolders: PropTypes.array,
  extraTexts: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      placeHolders: PropTypes.array,
      marginTop: PropTypes.number,
    }),
  ),
};

export default Description;
